import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../enums/QueryKey';
import api from '../services';
import { NotificationDto } from '@callmart/types';

const getNotification = async (): Promise<NotificationDto> =>
    api.get<NotificationDto>('/notification').then((res) => res.data);

export function useNotification() {
    return useQuery({
        queryKey: [QueryKey.Notification],
        queryFn: getNotification,
        refetchInterval: 1000 * 60 * 3, // 3 minutes
    });
}
